/**
 * Part of edu099 project.
 *
 * @copyright  Copyright (C) 2022 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import OrgSearchBarApp from '@/app/front/org-search-bar-app';
import locale from 'element-ui/lib/locale';
import lang from 'element-ui/lib/locale/lang/zh-TW';
import vClickOutside from 'v-click-outside';

S.import('@main')
  .then(() => {
    Vue.use(vClickOutside);

    locale.use(lang);

    new Vue({
      name: 'org-search-bar',
      el: 'org-search-bar-app',
      components: {
        OrgSearchBarApp,
      }
    });
  });
